// extracted by mini-css-extract-plugin
export var absoluteContainer = "styles-module--absoluteContainer--m5LHf";
export var container = "styles-module--container--uM+nD";
export var image = "styles-module--image--sFmrN";
export var text = "styles-module--text--4giar";